<script setup>
import DatePicker from '@alireza-ab/vue3-persian-datepicker';
import {useMainOrdersStore} from "@/stores/mainOrders.js";
import {ref, watch} from "vue";
import {Icon} from "@iconify/vue";
import {gregorianDate} from "@/utils/gregorianDate.js";

const ordersStore = useMainOrdersStore()
const emit = defineEmits(['closeModal', 'updateCreatedFrom', 'updateCreatedTo', 'updateUpdatedFrom', 'updateUpdatedTo']);
const x = ref(null)
const props = defineProps({
  fields: {
    type: Array,
    default: ['createdFrom', 'createdTo', 'updatedFrom', 'updatedTo']
  },
  createdFrom: String,
  createdTo: String,
  updatedFrom: String,
  updatedTo: String,
})
const dpKey = ref(0)
const createdFrom = ref(props.createdFrom ? props.createdFrom : null)
const createdTo = ref(props.createdTo ? props.createdTo : null)
const updatedFrom = ref(props.updatedFrom ? props.updatedFrom : null)
const updatedTo = ref(props.updatedTo ? props.updatedTo : null)

function convertTimestamp(timestamp) {
  return gregorianDate(timestamp, 'YYYY-MM-DD')
}

function resetCreatedFrom() {
  createdFrom.value = null
  saveCreatedFrom();
}
function resetCreatedTo() {
  createdTo.value = null
  saveCreatedTo();
}
function resetUpdatedFrom() {
  updatedFrom.value = null
  saveUpdatedFrom();
}
function resetUpdatedTo() {
  updatedTo.value = null
  saveUpdatedTo();
}

function saveCreatedFrom() {
  emit('updateCreatedFrom', createdFrom.value)
}

function saveCreatedTo() {
  emit('updateCreatedTo', createdTo.value)
}

function saveUpdatedFrom() {
  emit('updateUpdatedFrom', updatedFrom.value)
}

function saveUpdatedTo() {
  emit('updateUpdatedTo', updatedTo.value)
}
</script>

<template>
  <div class="grid grid-cols-2 gap-2" dir="ltr">
    <date-picker v-if="fields.includes('createdFrom')" clearable modal color="gray" :column="1" locale="en" :locale-config="{en:{dir:{input:'ltr'}}}"
                 input-format="D MMM YYYY" mode="single" format="t"
                 :styles="{background: 'rgb(15,23,42)', 'text-color':'#ccc', 'primary-color': '#3f69a3', 'secondary-color': '#779dd3', 'border-color': 'transparent', 'icon-background': 'rgb(15,23,42)', 'clear-background': 'rgb(15,23,42)'}"
                 display-format="D MMM YYYY" class="bg-slate-900"
                 label="Created From:" :auto-submit="false" @submit="saveCreatedFrom" @clear="resetCreatedFrom"
                 v-model="createdFrom">
      <template #icon>
        <Icon icon="uil:calendar-alt" color="white" class="size-5"/>
      </template>
      <template #clear>
        <Icon icon="si:close-fill"/>
      </template>
    </date-picker>
    <date-picker v-if="fields.includes('createdTo')" clearable modal color="gray" :column="1" locale="en" :locale-config="{en:{dir:{input:'ltr'}}}"
                 input-format="D MMM YYYY" mode="single" format="t"
                 :styles="{background: 'rgb(15,23,42)', 'text-color':'#ccc', 'primary-color': '#3f69a3', 'secondary-color': '#779dd3', 'border-color': 'transparent', 'icon-background': 'rgb(15,23,42)', 'clear-background': 'rgb(15,23,42)'}"
                 display-format="D MMM YYYY" class="bg-slate-900"
                 label="Created To:" :auto-submit="false" @submit="saveCreatedTo" @clear="resetCreatedTo"
                 v-model="createdTo">
      <template #icon>
        <Icon icon="uil:calendar-alt" color="white" class="size-5"/>
      </template>
      <template #clear>
        <Icon icon="si:close-fill"/>
      </template>
    </date-picker>
    <date-picker v-if="fields.includes('updatedFrom')" clearable modal color="gray" :column="1" locale="en" :locale-config="{en:{dir:{input:'ltr'}}}"
                 input-format="D MMM YYYY" mode="single" format="t"
                 :styles="{background: 'rgb(15,23,42)', 'text-color':'#ccc', 'primary-color': '#3f69a3', 'secondary-color': '#779dd3', 'border-color': 'transparent', 'icon-background': 'rgb(15,23,42)', 'clear-background': 'rgb(15,23,42)'}"
                 display-format="D MMM YYYY" class="bg-slate-900"
                 label="Updated From:" :auto-submit="false" @submit="saveUpdatedFrom" @clear="resetUpdatedFrom"
                 v-model="updatedFrom">
      <template #icon>
        <Icon icon="uil:calendar-alt" color="white" class="size-5"/>
      </template>
      <template #clear>
        <Icon icon="si:close-fill"/>
      </template>
    </date-picker>
    <date-picker v-if="fields.includes('updatedTo')" clearable modal color="gray" :column="1" locale="en" :locale-config="{en:{dir:{input:'ltr'}}}"
                 input-format="D MMM YYYY" mode="single" format="t"
                 :styles="{background: 'rgb(15,23,42)', 'text-color':'#ccc', 'primary-color': '#3f69a3', 'secondary-color': '#779dd3', 'border-color': 'transparent', 'icon-background': 'rgb(15,23,42)', 'clear-background': 'rgb(15,23,42)'}"
                 display-format="D MMM YYYY" class="bg-slate-900"
                 label="Updated To:" :auto-submit="false" @submit="saveUpdatedTo" @clear="resetUpdatedTo"
                 v-model="updatedTo">
      <template #icon>
        <Icon icon="uil:calendar-alt" color="white" class="size-5"/>
      </template>
      <template #clear>
        <Icon icon="si:close-fill"/>
      </template>
    </date-picker>
  </div>
</template>

<style lang="scss">
.pdp-label {
  @apply text-sm;
  margin-bottom: 0.25rem !important;
}

.pdp-icon {
  padding: 0 !important;
}

.pdp-clear {
  position: static !important;
  left: unset !important;
  padding: 0 !important;
}

.pdp-group {
  display: flex;
  gap: .5rem;
  padding: 0.5rem;
  background-color: rgb(15, 23, 42) !important;
  border-radius: 0.5rem;
  justify-content: space-between;
  align-items: center !important;

  input:focus-visible {
    outline: 0;
  }
}
</style>